<!--  FINANCE VIDEO  -->

<ui-video
	*ngIf="quote.video?.video_id !== null"
	[platform]="quote.video.video_platform"
	[id]="quote.video.video_id"
></ui-video>

<!--  END FINANCE VIDEO  -->

<div [ngSwitch]="quote.facility_type">
	<!--  HP INFO  -->

	<div *ngSwitchCase="'HP'" class="written-content padded">
		<h4>What is Hire Purchase Car Finance (HP)?</h4>
		<p>
			HP stands for Hire Purchase and has two elements of a lease and a loan. HP is most common form of car
			finance in the Industry.
		</p>

		<h4>How Does HP work?</h4>
		<p>
			When you find a vehicle that you want to buy from us, whether it be a vehicle we have in stock or one we are
			sourcing for you we would discuss your finance options with you. Hire Purchase can be taken out with a Zero
			Deposit if required however we typically recommend 5 - 10% as an upfront payment.
		</p>
		<p>
			Once you have paid the deposit on collection of the vehicle the balance is then paid off over a pre agreed
			finance term in regular monthly instalments. Typically 12 - 60 months.
		</p>
		<p>
			During the time that you are making the repayments to the finance lender you are effectively ”hiring” the
			vehicle.
		</p>
		<p>
			Once you come to the end of the hire purchase term and the final repayment has been made the vehicle then
			belongs to you “purchase”. Most hire purchase car finance agreements may also have a small admin fee or
			otherwise referred to as an option to purchase fee at the end of agreement.
		</p>

		<h4>Can I sell my car whilst on Hire Purchase?</h4>
		<p>
			Typically, because you don’t own the car outright until you finish all re-payments and the option to
			purchase fee (as it belongs to the finance company) you are unable to sell your car privately.
		</p>
		<p>
			However, you can part exchange your vehicle with us and take out a fresh finance agreement on an alternative
			vehicle. We will request a car finance settlement from you which you are able to obtain from your current
			lender. Our next step would be to value your vehicle against the new car you are looking at and work out a
			suitable deal for you.
		</p>

		<h4>Why Consider Hire Purchase?</h4>
		<ul>
			<li>Low Deposits - Use your personal savings for other things, or leverage your money for business.</li>
			<li>You decide the finance term typically from 12 - 60 months.</li>
			<li>A fixed interest affordable monthly payment.</li>
			<li>Attractive rates, typically lower then personal loans.</li>
			<li>
				Available for those who have had trouble obtaining loans may still be accepted for a Hire Purchase
				agreement subject to affordability checks.
			</li>
		</ul>
	</div>

	<!--  END HP INFO  -->

	<!--  PCP INFO  -->

	<div *ngSwitchCase="'PCP'" class="written-content padded">
		<h4>What is a Personal Contract Purchase?</h4>
		<p>
			A Personal Contact Purchase or PCP as it is known in short is slightly different to a conventional hire
			purchase car finance agreement. It is becoming more popular over recent years and has some benefit’s and can
			sometime’s be more attractive to customer’s as they can afford a more expensive car for less monthly
			payments.
		</p>
		<p>
			Payments would be made over an agreed period of time, anything from 2 – 4 Years and at the end of the
			finance term you can.
		</p>
		<ul>
			<li>Hand the car back with no additional payments required.</li>
			<li>Part Exchange the vehicle with us for a new finance deal.</li>
			<li>
				Decide to fully buy the car outright by paying the Guaranteed Future Value figure often refereed to as
				the “balloon” payment.
			</li>
		</ul>
		<p>
			It is important that you have a reasonably accurate understanding of what annual mileage you would be doing
			if you decided to just hand the car back. As should you go over the agreed mileage limitation you will be
			charged an additional sum on a pence per mile basis.
		</p>

		<h4>Should I consider Personal Contract Purchase PCP?</h4>
		<p>
			A Personal Contract Purchase PCP style of agreement is typically suited to our customers who wish to change
			their vehicles regularly with us, but have a requirement to having lower monthly finance figures. The option
			is yours to purchase the car outright at the end of the agreement.
		</p>
		<p>
			Because this style of car finance agreement is flexible it is best suited and sometimes only available to
			those with a good credit score. This car finance option may not be available to those with a poor or bad
			credit score.
		</p>
		<p>
			Personal Contract Purchase PCP can be cost effective in keeping your monthly payments lower then Hire
			Purchase, however you should maybe think of it as renting a car for a couple of years but also have the
			option to buy at the end. However typically the majority of our customer’s would talk to us about part
			exchanging and taking our a new finance agreement with us.
		</p>
	</div>

	<!--  END PCP INFO  -->

	<!--  OTHER INFO  -->

	<div *ngSwitchDefault class="written-content padded">
		<h4>What is {{ quote.facility_type }} finance?</h4>
		<p>
			For more information about this type of finance please contact us and our experienced sales staff will be
			happy to help.
		</p>
	</div>

	<!--  END OTHER INFO  -->
</div>
